import SoundManager from "../../../../../lib/html5-software-library/src/ranj/audio/SoundManager";
import Button from "../../../../../lib/html5-software-library/src/ranj/components/buttons/Button";
import RevisableLanguagePack from "../../../../../lib/html5-software-library/src/ranj/language/RevisableLanguagePack";
import LayoutManager from "../../../../../lib/html5-software-library/src/ranj/layout/LayoutManager";
import AnimationFactory from "../../../../../lib/html5-software-library/src/ranj/ui/animation/AnimationFactory";
import AnimationOptions from "../../../../../lib/html5-software-library/src/ranj/ui/animation/AnimationOptions";
import AssetLibrary from "../../../core/assetloading/AssetLibrary";
import SoundType from "../../../core/sound/util/SoundType";
import AbstractMediator from "../../../core/ui/AbstractMediator";
import ClickEaterFactory from "../../../core/ui/ClickEaterFactory";
import SkinKeyRegistry from "../../../core/ui/SkinKeyRegistry";
import { OnboardingStep } from "../../onboarding/model/OnboardingStep";
import ConversationTeaserEvent from "../event/ConversationTeaserEvent";

export default class ConversationTileMediator extends AbstractMediator {
    /**
     * @constructor
     * @param {createjs.MovieClip} target 
     * @param {soma.EventDispatcher} dispatcher 
     * @param {LayoutManager} layoutManager 
     * @param {ClickEaterFactory} clickEaterFactory 
     * @param {RevisableLanguagePack} languagePack 
     * @param {AssetLibrary} assetLibrary
     * @param {PullContentManager} pullContentManager
     * @param {SoundManager} soundManager
     */
    constructor(target, dispatcher, layoutManager, clickEaterFactory, languagePack, pullContentManager, soundManager) {
        super(target, dispatcher, layoutManager, clickEaterFactory);

        this._languagePack = languagePack;
        this._pullContentManager = pullContentManager;
        this._soundManager = soundManager;

        this._chapterId = this.getCustomData().chapterId;
        this._scenarioId = this.getCustomData().scenarioId;
        this._dialogId = this.getCustomData().dialogId;

        this._onRollOverButtonBound = this._onRollOverButton.bind(this);
        this._onRollOutButtonBound = this._onRollOutButton.bind(this);
    }

    async initialize() {
        super.initialize();

        this._bounds = this._target.getBounds();

        /** @type {Button} */
        this._button = this.createButton(this._target.button, this._handleButtonClick.bind(this), SoundType.BUTTON_CLICK);
        this._button.addEventListener('rollover', this._onRollOverButtonBound);
        this._button.addEventListener('rollout', this._onRollOutButtonBound);

        this._target.conAttract.gotoAndPlay(0);
    }

    setEnabled(value) {
        this._button.setEnabled(value);

        if (value) {
            this._target.conAttract.gotoAndPlay(0);
        } else {
            this._target.conAttract.gotoAndStop(0);
        }
    }

    async show(direction = 1, reset = false) {
        if (reset) {
            this._target.alpha = 0;
            this._target.x = this._bounds.width * direction;
        }

        this._target.visible = true;
        await createjs.Tween.get(this._target, { override: true })
            .to({
                alpha: 1,
                x: 0,
            }, 450, createjs.Ease.sineInOut)
            .toPromise();
    }

    showInstant() {
        this._target.visible = true;
        this._target.alpha = 1;
        this._target.x = 0;
    }

    async hide(direction = 1, reset = false) {
        if (reset) {
            this._target.alpha = 1;
            this._target.x = 0;
        }

        await createjs.Tween.get(this._target, { override: true })
            .to({
                alpha: 0,
                x: this._bounds.width * direction,
            }, 450, createjs.Ease.sineInOut)
            .toPromise();
        this._target.visible = true;
    }

    hideInstant() {
        this._target.visible = false;
        this._target.alpha = 0;
    }

    _handleButtonClick() {
        this.finishOnboarding(OnboardingStep.SELECT_SCENARIO);

        this.dispatch(ConversationTeaserEvent.HIDE);
        // this._target.conAttract.gotoAndStop(0);
        this.showConversationPreview();
    }

    showConversationPreview() {
        // this._target.conAttract.gotoAndStop(0);

        this.openScreen(SkinKeyRegistry.CONVERSATION_PREVIEW_SCREEN_SKIN, {
            animationType: AnimationFactory.FADE_IN,
            animationOptions: new AnimationOptions(0, 450, createjs.Ease.sineInOut),
        }, {
            dialogId: this._dialogId,
        });
    }

    _onRollOverButton() {
        this._soundManager.playSound(SoundType.CHARACTER_HOVER);

        const titleText = this._languagePack.getText(`conversationTeasers.${this._chapterId}.${this._dialogId}.title`);
        const descriptionText = this._languagePack.getText(`conversationTeasers.${this._chapterId}.${this._dialogId}.description`);
        const conversationTeaserEvent = new ConversationTeaserEvent(ConversationTeaserEvent.SHOW, titleText, descriptionText);
        this.dispatch(conversationTeaserEvent.type, { data: conversationTeaserEvent });
    }

    _onRollOutButton() {
        this.dispatch(ConversationTeaserEvent.HIDE);
    }

    get dialogId() {
        return this._dialogId;
    }
}